(() => {
  if (window.wbQuickAddViewCart) return;
  window.wbQuickAddViewCart = true;

  const STATE_CLASS = 'qa-added';
  const LINK_CLASS = 'js-qa-view-cart';

  const getDrawer = (el) => (el && el.closest ? el.closest('quick-add-drawer') : null);

  function getParts(drawer) {
    const form = drawer.querySelector('product-form .js-product-form');
    if (!form) return null;
    return {
      wrap: form.querySelector('.product-info__add-to-cart'),
      qty: form.querySelector('quantity-input'),
      addBtn: form.querySelector('[name="add"]')
    };
  }

  function showViewCart(drawer) {
    const parts = getParts(drawer);
    if (!parts || !parts.addBtn) return;

    let link = drawer.querySelector(`.${LINK_CLASS}`);
    if (!link) {
      link = document.createElement('a');
      link.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
      link.className = `btn btn--primary w-full ${LINK_CLASS}`;
      link.textContent = drawer.dataset.viewCartText || 'View cart';
      parts.addBtn.insertAdjacentElement('afterend', link);
    }

    const addBtnHadFocus = document.activeElement === parts.addBtn;
    parts.addBtn.hidden = true;
    if (parts.qty) parts.qty.hidden = true;
    if (parts.wrap) parts.wrap.classList.add(STATE_CLASS);
    link.hidden = false;
    if (addBtnHadFocus) link.focus();
  }

  function reset(drawer) {
    const link = drawer.querySelector(`.${LINK_CLASS}`);
    if (!link) return;
    link.remove();

    const parts = getParts(drawer);
    if (!parts) return;
    if (parts.addBtn) parts.addBtn.hidden = false;
    if (parts.wrap) parts.wrap.classList.remove(STATE_CLASS);
    if (parts.qty) {
      parts.qty.hidden = false;
      const input = parts.qty.querySelector('input[name="quantity"]');
      if (input) input.value = input.defaultValue || input.min || 1;
    }
  }

  const handleAdded = (evt) => {
    const drawer = getDrawer(evt.target);
    if (drawer) showViewCart(drawer);
  };
  document.addEventListener('on:cart:add', handleAdded);
  document.addEventListener('on:line-item:change', handleAdded);

  const handleReset = (evt) => {
    const drawer = getDrawer(evt.target);
    if (drawer) reset(drawer);
  };
  document.addEventListener('on:quickbuy:before-open', handleReset);
  document.addEventListener('on:quickbuy:after-close', handleReset);
  document.addEventListener('on:variant:change', handleReset);

  document.addEventListener('click', (evt) => {
    const link = evt.target.closest ? evt.target.closest(`.${LINK_CLASS}`) : null;
    if (!link) return;
    if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;

    const drawer = getDrawer(link);
    if (document.querySelector('cart-drawer')) {
      evt.preventDefault();
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        detail: { opener: (drawer && drawer.opener) || null }
      }));
    } else if (drawer && window.theme && window.location.pathname === theme.routes.cart) {
      evt.preventDefault();
      drawer.close();
    }
  });
})();